import {type EventParametersMap, sendToStatist} from '@time-webkit/statist';
import {type Post} from '@mattermost/types/posts';

import {Locations} from './constants';

const LOCATION_TO_ACTION_SOURCE_MAP = {
    [Locations.SEARCH]: 'search',
    [Locations.CENTER]: 'channel',
    [Locations.RHS_ROOT]: 'thread',
    [Locations.RHS_COMMENT]: 'thread',
    [Locations.THREADS]: 'threads',
    [Locations.ACTIVITY_FEED]: 'mentions',
    [Locations.PINNED]: 'pinned',
    [Locations.SAVED]: 'saved',
    [Locations.NO_WHERE]: 'channel',
} as const;

export function logPostAction(
    action: EventParametersMap['app.postAction']['action'],
    inputType: EventParametersMap['app.postAction']['inputType'],
    location: keyof typeof Locations = 'CENTER',
    postLikeObj: Pick<Post, 'id'| 'channel_id'>,
    searchIndex?: number,
) {
    sendToStatist('app.postAction', {
        action,
        actionSource: LOCATION_TO_ACTION_SOURCE_MAP[location],
        inputType,
        postId: postLikeObj.id,
        channelId: postLikeObj.channel_id,
    });

    if (location === Locations.SEARCH && typeof searchIndex === 'number') {
        sendToStatist('searchUpperscreen.action', {
            resultAction: action,
            resultType: 'message',
            resultNumber: searchIndex + 1,
            postid: postLikeObj.id,
            inputType,
        });
    }
}
